module.exports = __webpack_public_path__ + "img/mb.abd55310.png";